export const allFilters = [
  {
    title: "Players",
    allselected: false,
    columns: 1,
    items: [
      {
        name: "Player 1",
        selected: true,
        amount: 0,
      },
      {
        name: "Player 2",
        selected: false,
        amount: 0,
      },
    ],
    layout: { i: "players", x: 0, y: 0, w: 1, h: 3, static: true },
  },
  {
    title: "Shots",
    allselected: false,
    columns: 1,
    items: [
      {
        name: "1st Serve Deuce",
        selected: true,
        amount: 0,
      },
      {
        name: "1st Serve Ad",
        selected: true,
        amount: 0,
      },
      {
        name: "2nd Serve Deuce",
        selected: true,
        amount: 0,
      },
      {
        name: "2nd Serve Ad",
        selected: true,
        amount: 0,
      },
      {
        name: "Return 1st Deuce",
        selected: false,
        amount: 0,
      },
      {
        name: "Return 1st Ad",
        selected: false,
        amount: 0,
      },
      {
        name: "Return 2nd Deuce",
        selected: false,
        amount: 0,
      },
      {
        name: "Return 2nd Ad",
        selected: false,
        amount: 0,
      },
      {
        name: "Rally Shot",
        selected: false,
        amount: 0,
      },
      {
        name: "Keypoint Shot",
        selected: false,
        amount: 0,
      },
      {
        name: "After 1st Serve",
        selected: false,
        amount: 0,
      },
      {
        name: "After 2nd Serve",
        selected: false,
        amount: 0,
      },
      {
        name: "After Ret 1st Serve",
        selected: false,
        amount: 0,
      },
      {
        name: "After Ret 2nd Serve",
        selected: false,
        amount: 0,
      },
      {
        name: "Serve Volleys",
        selected: false,
        amount: 0,
      },
      {
        name: "Approach Shots",
        selected: false,
        amount: 0,
      },
      {
        name: "Passing Shots",
        selected: false,
        amount: 0,
      },
    ],
    layout: { i: "shots", x: 0, y: 3, w: 1, h: 15, static: true },
  },
  {
    title: "Directions",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Inside Out",
        selected: true,
        amount: 0,
      },
      {
        name: "Inside In",
        selected: true,
        amount: 0,
      },
      {
        name: "Cross Court",
        selected: true,
        amount: 0,
      },
      {
        name: "Down The Line",
        selected: true,
        amount: 0,
      },
      {
        name: "Centre",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "directions", x: 0, y: 18, w: 1, h: 6, static: true },
  },
  {
    title: "Winners",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Player 1",
        selected: true,
        amount: 0,
      },
      {
        name: "Player 2",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "winners", x: 1, y: 0, w: 1, h: 3, static: true },
  },
  {
    title: "Forehand",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Topspin",
        selected: true,
        amount: 0,
      },
      {
        name: "Drive/Power",
        selected: true,
        amount: 0,
      },
      {
        name: "Slice",
        selected: true,
        amount: 0,
      },
      {
        name: "Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Overhead",
        selected: true,
        amount: 0,
      },
      {
        name: "Lob",
        selected: true,
        amount: 0,
      },
      {
        name: "Drop Shot",
        selected: true,
        amount: 0,
      },
      {
        name: "Smash",
        selected: true,
        amount: 0,
      },
      {
        name: "Approach",
        selected: true,
        amount: 0,
      },
      {
        name: "Drive Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Half Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Flat",
        selected: true,
        amount: 0,
      },
      {
        name: "Kick",
        selected: true,
        amount: 0,
      },
      {
        name: "Drop Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Poach Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Bounce Overhead",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "forehand", x: 1, y: 3, w: 1, h: 10, static: true },
  },
  {
    title: "Backhand",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Topspin",
        selected: true,
        amount: 0,
      },
      {
        name: "Drive/Power",
        selected: true,
        amount: 0,
      },
      {
        name: "Slice",
        selected: true,
        amount: 0,
      },
      {
        name: "Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Overhead",
        selected: true,
        amount: 0,
      },
      {
        name: "Lob",
        selected: true,
        amount: 0,
      },
      {
        name: "Drop Shot",
        selected: true,
        amount: 0,
      },
      {
        name: "Smash",
        selected: true,
        amount: 0,
      },
      {
        name: "Approach",
        selected: true,
        amount: 0,
      },
      {
        name: "Drive Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Half Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Flat",
        selected: true,
        amount: 0,
      },
      {
        name: "Kick",
        selected: true,
        amount: 0,
      },
      {
        name: "Drop Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Poach Volley",
        selected: true,
        amount: 0,
      },
      {
        name: "Bounce Overhead",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "backhand", x: 1, y: 10, w: 1, h: 10, static: true },
  },
  {
    title: "Reaches",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Balanced",
        selected: true,
        amount: 0,
      },
      {
        name: "Unbalanced",
        selected: true,
        amount: 0,
      },
      {
        name: "Time Poor",
        selected: true,
        amount: 0,
      },
      {
        name: "NA",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "reaches", x: 1, y: 17, w: 1, h: 5, static: true },
  },
  {
    title: "Scores",
    allselected: true,
    columns: 2,
    items: [
      {
        name: "00-00",
        selected: true,
        amount: 0,
      },
      {
        name: "15-00",
        selected: true,
        amount: 0,
      },
      {
        name: "30-00",
        selected: true,
        amount: 0,
      },
      {
        name: "00-15",
        selected: true,
        amount: 0,
      },
      {
        name: "15-15",
        selected: true,
        amount: 0,
      },
      {
        name: "30-15",
        selected: true,
        amount: 0,
      },
      {
        name: "00-30",
        selected: true,
        amount: 0,
      },
      {
        name: "15-30",
        selected: true,
        amount: 0,
      },
      {
        name: "30-30",
        selected: true,
        amount: 0,
      },
      {
        name: "00-40",
        selected: true,
        amount: 0,
      },
      {
        name: "15-40",
        selected: true,
        amount: 0,
      },
      {
        name: "30-40",
        selected: true,
        amount: 0,
      },
      {
        name: "40-15",
        selected: true,
        amount: 0,
      },
      {
        name: "40-30",
        selected: true,
        amount: 0,
      },
      {
        name: "40-00",
        selected: true,
        amount: 0,
      },
      {
        name: "Deuce",
        selected: true,
        amount: 0,
      },
      {
        name: "Srv Ad",
        selected: true,
        amount: 0,
      },
      {
        name: "Ret Ad",
        selected: true,
        amount: 0,
      },
      {
        name: "BP For",
        selected: true,
        amount: 0,
      },
      {
        name: "BP Agst",
        selected: true,
        amount: 0,
      },
      {
        name: "Gm Pts",
        selected: true,
        amount: 0,
      },
      {
        name: "TB Pts",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "scores", x: 4, y: 0, w: 0.5, h: 23, static: true },
  },
  {
    title: "Serves",
    allselected: true,
    columns: 2,
    items: [
      {
        name: "Wide",
        selected: true,
        amount: 0,
      },
      {
        name: "Body",
        selected: true,
        amount: 0,
      },
      {
        name: "T",
        selected: true,
        amount: 0,
      },
      {
        name: "Out",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "serves", x: 2, y: 6, w: 1, h: 5, static: true },
  },
  {
    title: "Outcome",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Winner",
        selected: true,
        amount: 0,
      },
      {
        name: "Forced Error",
        selected: true,
        amount: 0,
      },
      {
        name: "Unforced Error",
        selected: true,
        amount: 0,
      },
      {
        name: "In Play",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "outcome", x: 2, y: 11, w: 1, h: 5, static: true },
  },
  {
    title: "Rally Length",
    allselected: false,
    columns: 2,
    items: [
      {
        name: "Any",
        selected: true,
        amount: 0,
      },
      {
        name: "0-4",
        selected: false,
        amount: 0,
      },
      {
        name: "5-8",
        selected: false,
        amount: 0,
      },
      {
        name: "9+",
        selected: false,
        amount: 0,
      },
    ],
    layout: { i: "rally", x: 2, y: 16, w: 1, h: 5, static: true },
  },
  {
    title: "Games",
    allselected: true,
    columns: 2,
    items: [
      {
        name: "1",
        selected: true,
        amount: 0,
      },
      {
        name: "2",
        selected: true,
        amount: 0,
      },
      {
        name: "3",
        selected: true,
        amount: 0,
      },
      {
        name: "4",
        selected: true,
        amount: 0,
      },
      {
        name: "5",
        selected: true,
        amount: 0,
      },
      {
        name: "6",
        selected: true,
        amount: 0,
      },
      {
        name: "7",
        selected: true,
        amount: 0,
      },
      {
        name: "8",
        selected: true,
        amount: 0,
      },
      {
        name: "9",
        selected: true,
        amount: 0,
      },
      {
        name: "10",
        selected: true,
        amount: 0,
      },
      {
        name: "11",
        selected: true,
        amount: 0,
      },
      {
        name: "12",
        selected: true,
        amount: 0,
      },
      {
        name: "13",
        selected: true,
        amount: 0,
      },
      {
        name: "14",
        selected: true,
        amount: 0,
      },
      {
        name: "14+",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "games", x: 3, y: 0, w: 0.5, h: 16, static: true },
  },
  {
    title: "Sets",
    allselected: true,
    columns: 3,
    items: [
      {
        name: "1",
        selected: true,
        amount: 0,
      },
      {
        name: "2",
        selected: true,
        amount: 0,
      },
      {
        name: "3",
        selected: true,
        amount: 0,
      },
      {
        name: "4",
        selected: true,
        amount: 0,
      },
      {
        name: "5",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "sets", x: 2, y: 0, w: 1, h: 6, static: true },
  },
  {
    title: "Serve Form.",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Traditional",
        selected: true,
        amount: 0,
      },
      {
        name: "Eye",
        selected: true,
        amount: 0,
      },
      {
        name: "Squeeze",
        selected: true,
        amount: 0,
      },
      {
        name: "Tandem",
        selected: true,
        amount: 0,
      },
      {
        name: "2 Back",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "serveform", x: 2, y: 0, w: 1, h: 6, static: true },
  },
  {
    title: "Return Form.",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Traditional",
        selected: true,
        amount: 0,
      },
      {
        name: "2 Back",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "returnform", x: 2, y: 0, w: 1, h: 6, static: true },
  },
  {
    title: "Net Position",
    allselected: true,
    columns: 1,
    items: [
      {
        name: "Hold",
        selected: true,
        amount: 0,
      },
      {
        name: "Switch",
        selected: true,
        amount: 0,
      },
      {
        name: "Cover Middle",
        selected: true,
        amount: 0,
      },
      {
        name: "Left",
        selected: true,
        amount: 0,
      },
      {
        name: "Right",
        selected: true,
        amount: 0,
      },
    ],
    layout: { i: "netpos", x: 2, y: 0, w: 1, h: 6, static: true },
  },
];
